var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaseLaw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "64px",
    height: "55px",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 64 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Plan_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 64,
    height: 55
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1330820955296"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    d: "M8 1l33 0c1,0 1,1 1,1l0 43 0 2c0,1 -1,1 -1,1l-33 0c-1,0 -1,-1 -1,-1l0 -44c0,-1 1,-1 1,-1z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    points: "8,2 25,7 42,2 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    stroke: "#1E4887",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    d: "M21 12l29 -3c1,0 1,0 1,1l3 37 0 1c0,1 0,1 -1,1l-29 3c-1,0 -1,0 -1,-1l-3 -39c0,-1 0,-1 1,-1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    stroke: "#1E4887",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    d: "M27 10l29 0c1,0 1,1 1,1l0 37 0 1c0,1 -1,1 -1,1l-29 0c-1,0 -1,-1 -1,-1l0 -39c0,-1 1,-1 1,-1z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    x1: 31,
    y1: 27,
    x2: 52,
    y2: 27
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    x1: 31,
    y1: 31,
    x2: 52,
    y2: 31
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    x1: 31,
    y1: 35,
    x2: 52,
    y2: 35
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8CC63F",
    d: "M53 16c0,0 0,0 0,1 0,3 -2,5 -5,5 0,0 0,0 -1,0 0,0 0,0 0,-1 0,-3 2,-5 5,-5 0,0 0,0 1,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4DB848",
    d: "M50 22c0,0 -1,0 -1,0 -3,0 -5,-3 -5,-5 0,-3 1,-4 3,-5 -1,2 -1,4 1,5 2,1 3,2 3,5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A950",
    d: "M50 22l0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0,0 0,0 0,0l0 0c0,0 0,0 0,0l0 0c0,0 0,0 0,0l0 0c0,0 0,0 0,0l0 0 0 0c0,0 0,0 0,0l0 0 0 0 0 0c0,0 0,0 0,0l0 0 0 0 0 0c0,0 0,0 0,0 0,0 0,0 -1,0 0,0 0,0 0,-1 0,-1 0,-2 1,-3 1,1 1,2 1,3z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EE3A43",
    cx: 48,
    cy: 15,
    r: 1
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    x1: 31,
    y1: 39,
    x2: 52,
    y2: 39
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    x1: 31,
    y1: 42,
    x2: 52,
    y2: 42
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseLaw);
export default __webpack_public_path__ + "static/media/caseLaw.935ada25cfe20f5063aeba7be094722c.svg";
export { ForwardRef as ReactComponent };